import { useCallback, useContext, useEffect, useState } from 'react';
import { QueryParamsContext } from '~/providers/query-params';
import { setUtilitySelection } from '~/screens/select-utility/select-utility-utils';
import {
  SelectUtility,
  SelectUtilityContext,
} from '~/screens/select-utility/select-utility.component';
import { sendToSegment, updateTrackingIdentity } from '~/utils/tracking';

export interface SelectUtilityWrapperProps {
  onUtilitySelect: () => any;
  copy?: any;
}
const trackStarted = context => {
  sendToSegment({
    type: 'utility_step_started',
    utilityId: context.utilityId,
    zipCode: context.zipCode,
  });
};
const trackCompleted = context => {
  sendToSegment({
    type: 'utility_step_completed',
    ...context,
  });
};
export const SelectUtilityWrapper = ({ onUtilitySelect, copy }: SelectUtilityWrapperProps) => {
  const { unparsedQueryParams } = useContext(QueryParamsContext);
  const [context, setContext] = useState({
    zipCode: unparsedQueryParams?.zipCode || '',
    utilityId: unparsedQueryParams?.utilityId || '',
  } as SelectUtilityContext);

  useEffect(() => {
    trackStarted(context);
  }, []);

  const utilitySelectHandler = useCallback(
    async data => {
      const { id, funnelTrack } = await setUtilitySelection(data.zipCode, data.utilityId);
      updateTrackingIdentity(undefined, id);
      setContext(data);
      /**
       * call onUtilitySelect so that the
       * parent want to do something(like routing) with the data.
       */
      onUtilitySelect();
      trackCompleted({
        utilityId: id,
        zipCode: data.zipCode,
        funnelTrack,
      });
    },
    [context.utilityId],
  );
  return <SelectUtility context={context} next={utilitySelectHandler} overrideCopy={copy} />;
};
